export default __webpack_public_path__ + "static/media/13.050a899f.jpeg";